import { Box, CircularProgress, Divider, Tooltip, useTheme } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import { FormattedMessage, useIntl } from 'react-intl'

interface JobsTabsItemProps {
  hasJobs: boolean
  areJobsRunning: boolean
  areAllJobsRunning: boolean
  clearJobs: () => void
  children: JSX.Element
}

function JobsTabsItem({ children, hasJobs, areJobsRunning, areAllJobsRunning, clearJobs }: JobsTabsItemProps) {
  const theme = useTheme()
  const intl = useIntl()
  return (
    <>
      {hasJobs && (
        <>
          <Box maxHeight={theme.spacing(40)} overflow="auto" role="list" mt={0.5}>
            {children}
          </Box>
          <Divider />
        </>
      )}
      <Box px={1} pt={1} pb={1}>
        {hasJobs ? (
          <Tooltip title={intl.formatMessage({ id: 'jobs.tooltip.clear' })}>
            <span>
              <Button color="error" aria-label="clear" variant="text" disabled={areAllJobsRunning} onClick={clearJobs}>
                <FormattedMessage id="common.button.clear" />
              </Button>
            </span>
          </Tooltip>
        ) : !areJobsRunning ? (
          <Box display="flex" justifyContent="center" alignItems="center" mb={2.5} mt={3.5}>
            <Typography variant="body2" color="textSecondary">
              <FormattedMessage id="jobs.tilesets.nojobs" />
            </Typography>
          </Box>
        ) : (
          !hasJobs && (
            <Box display="flex" justifyContent="center" alignItems="center" mb={3} mt={3}>
              <CircularProgress size={24} />
            </Box>
          )
        )}
      </Box>
    </>
  )
}

export default JobsTabsItem
